import { walletApi } from "../api";

const BillsPaymentModule = () => {
    return {
        GetServiceType: function (service) {
            return walletApi.get(`BillsPayment/getBillers/${service}`);
        },
        BuyAirtime: function (data) {
            return walletApi.post(`BillsPayment/airtime/vend`, data);
        },
        GetDataPlans: function (data) {
            return walletApi.get(
                `BillsPayment/data/plans?serviceId=${data?.serviceId}&serviceName=${data?.serviceName}&productCode=${data?.productCode}`
            );
        },
        BuyData: function (data) {
            return walletApi.post(`BillsPayment/data/vend`, data);
        },
        GetCablePlans: function (data) {
            return walletApi.get(
                `BillsPayment/cabletv/plans?serviceId=${data?.serviceId}&serviceName=${data?.serviceName}&productCode=${data?.productCode}`
            );
        },
        ValidateCustomer: function (data) {
            return walletApi.post(
                `BillsPayment/${data.type}/validate-customer`,
                data.data
            );
        },
        BettingPay: function (data) {
            return walletApi.post(`BillsPayment/betting/pay`, data);
        },
        TvCablePay: function (data) {
            return walletApi.post(`BillsPayment/cabletv/pay`, data);
        },
        ElectricityPay: function (data) {
            return walletApi.post(`BillsPayment/electricity/pay`, data);
        },
    };
};

export const BillsPaymentService = {
    BillsPaymentModule: BillsPaymentModule,
};
